export class RefreshTokenUndefinedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'RefreshTokenUndefined';
  }
}

export class RefreshTokenUnexpectedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'RefreshTokenUnexpected';
  }
}
